@use 'vars';
@import 'mixins';

.iq-critique {
  @include scrollable-container;

  display: flex;
  flex-direction: column;
  gap: vars.$gap-medium;
  padding: vars.$padding-small;
  height: 100%;
  min-width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  &__rewrite {
    margin-top: vars.$margin-xsmall;
  }

  &--not-stand-alone {
    max-height: 220px;
  }
}
